<template>
    <div class="edit-label" v-loading="loading">
     <div class="edit-label-header">
         <span @click="goBack">
         <i class="el-icon-arrow-left"></i>
         <span>返回</span>
         </span>
     </div>

    <div class="edit-label-content">


        <el-form label-width="120px" label-position="left" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
            <div class="edit-label-content-name">
                <div class="label_icon">
                    <img  v-if="resData.labelType=='0'" :src="`${baseUrl}images/static_label_icon.png`" />
                    <img  v-if="resData.labelType=='1'" :src="`${baseUrl}images/dynamic_label_icon.png`" />
                </div>
                <span  v-text="resData.labelName"></span></div>
            <el-form-item label="标签名称：" >
                <span class="input-text" >{{resData.labelName|| ''}}</span>
            </el-form-item>
            <el-form-item label="标签ID：" >
                <span class="input-text">{{resData.labelId}}</span>
            </el-form-item>
            <el-form-item label="标签类型：">
                <span>{{resData.labelType == '0' ? '静态标签' : '动态标签'}}</span>
            </el-form-item>
            <el-form-item v-if="resData.labelType == '0'" label="包含部门：" >
                <span class="input-text">{{daptNames || '无'}}</span>
            </el-form-item>
            <el-form-item v-if="resData.labelType == '0'"  label="可管理岗位：" >
                <span class="input-text">{{postName || '无'}}</span>
            </el-form-item>
            <div v-if="resData.labelType == '1'">
                <el-table
                        :data="tableData"
                        style="width: 100%">
                    <el-table-column
                            prop="labelType"
                            label="条件"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="conditionType"
                            label="比较条件"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="sexText"
                            label="条件值">
                    </el-table-column>
                </el-table>
            </div>
            <!--<el-form-item label="可管理岗位：" prop="postList">-->
                <!--<el-select v-model="postList" multiple placeholder="请选择可管理岗位" class="w100">-->
                    <!--<el-option-->
                            <!--v-for="item in jobList"-->
                            <!--:key="item.postId"-->
                            <!--:label="item.postName"-->
                            <!--:value="item.postId"-->
                    <!--&gt;-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item class="tx-c">-->
                <!--<el-button type="primary" @click="submitForm('ruleForm')" >确定</el-button>-->
            <!--</el-form-item>-->
        </el-form>
    </div>
  </div>
</template>

<script>
    import { getStatInfo ,handleAddPost} from '@/api/managementCenter/labelManage';
    import {getAllJobList} from '@/api/managementCenter/jobManage';
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    export default {
        name: "addLabel",
        data(){
            return {
                baseUrl: process.env.BASE_URL,
                loading:false,
                postList:[],
                form: {
                    labelId:'',
                    postList:[]
                },
                rules: {
                    postList: [
                        { required: true, message: "请选择可管理岗位", trigger: "blur" }
                    ]
                },
                resData:{},
                jobList:[],
                departmentData: [],
                daptNames: '', //回显部门字符串
                postName: '', //回显岗位字符串
                tableData:[],
                labelTypeList:[
                    {
                        name:'名称',
                        value:'name'
                    },
                    {
                        name:'性别',
                        value:'SEX'
                    },
                    {
                        name:'年龄',
                        value:'AGE'
                    },
                    {
                        name:'部门',
                        value:'DEPT'
                    },
                    {
                        name:'角色',
                        value:'ROLE'
                    },
                    {
                        name:'用户类型',
                        value:'USER_TYPE'
                    },
                    {
                        name:'入学入职年份',
                        value:'ADM_DATE'
                    }
                ],
                conditionData: [
                    {
                        value: 'name',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            },
                            {
                                name: '不等于',
                                value: 'neq'
                            }
                        ]
                    },
                    {
                        value: 'SEX',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            }
                        ]
                    },
                    {
                        value: 'AGE',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            },
                            {
                                name: '模糊匹配',
                                value: 'gt'
                            },
                            {
                                name: '大于',
                                value: 'lt'
                            },
                            {
                                name: '大于等于',
                                value: 'gte'
                            },
                            {
                                name: '小于等于',
                                value: 'lte'
                            }
                        ]
                    },
                    {
                        value: 'DEPT',
                        list: [
                            {
                                name: '本部门',
                                value: 'deplevel'
                            },
                            {
                                name: '本部门以及下级部门',
                                value: 'depdownlevel'
                            }
                        ]
                    },
                    {
                        value: 'ROLE',
                        list: [
                            {
                                name: '存在',
                                value: 'in'
                            },
                            {
                                name: '不存在',
                                value: 'nin'
                            }
                        ]
                    },
                    {
                        value: 'USER_TYPE',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            }
                        ]
                    },
                    {
                        value: 'ADM_DATE',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            },
                            {
                                name: '模糊匹配',
                                value: 'gt'
                            },
                            {
                                name: '大于',
                                value: 'lt'
                            },
                            {
                                name: '大于等于',
                                value: 'gte'
                            },
                            {
                                name: '小于等于',
                                value: 'lte'
                            }
                        ]
                    }
                ],
            }
        },
        components:{
        },
        mounted(){
            this.getJobListFn();
            this.getDeptTreeData();
        },
        methods:{
            //获取部门数据
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }

                    }
                }).catch(err=>{

                })

            },
            //获取岗位数据
            getJobListFn(){
                getAllJobList().then(({data}) => {
                    if(data.code == 0){
                        this.jobList=data.data||[];
                    }else{
                        this.$message.warning( data.msg||"获取岗位失败！" );
                    }
                }).catch(err=>{
                })
            },
            setId(id){
                this.loading=true;
                this.daptNames = ''
                getStatInfo(id).then(({data})=>{
                    this.loading=false;
                    if(data.code == 0){
                        this.postList = []
                        this.resData=data.data||{};
                        if(this.resData.labelType == '1') {
                            let arr =  (JSON.parse( this.resData.labelConditions)).conditions
                            arr.forEach((item) =>{
                                this.tableData.push({
                                    labelType: item.conditionName,
                                    conditionType: item.campareName,
                                    sexText: item.textName
                                })
                            })
                            this.form.labelId=this.resData.labelId;
                        }
                        let depts = []
                        let posts = []
                        if(this.resData.labelType == '0') {
                            this.resData.deptList.forEach((item) =>{
                                depts.push(item.deptName)

                            })
                            this.resData.postList.forEach((item) =>{
                                posts.push(item.postName)
                            })
                            this.daptNames = depts.join(',')
                            this.postName = posts.join(',')
                        }
                    }else{
                        this.$message.warning( data.msg||"获取标签信息失败！" );
                    }
                }).catch(err=>{
                    this.loading=false;
                })
            },
            goBack(){
                this.$emit('goBack',this.resData)
            },
            saveOrUpdate(){
                this.loading = true;
                handleAddPost(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "修改成功!" );
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning(  data.msg||"保存失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveOrUpdate()
                    } else {
                        return false;
                    }
                });
            },
        },
        watch:{
            postList(val){
                this.form.postList=(val||[]).map(i=>{
                    return {postId:i};
                })
            },
        },
        filters:{
            labelTypeFilter(val){
                let labelTypeList=[
                        {
                            name:'请选择',
                            value:''
                        },
                        {
                            name:'静态标签',
                            value:'0'
                        }
                       ,{
                            name:'动态标签',
                            value:'1'
                        }
                        ];
                let obj = labelTypeList.find(i=>val==i.value)||{};
                return obj.name;
            }

        }
    }
</script>

<style scoped lang="less">
    .edit-label{
        .edit-label-header{
            height: 40px;
            line-height: 40px;
            padding-left: 10px;
            background: #F4F4F4 ;
            box-sizing: border-box;
            margin-bottom: 20px;
            >span{
                color: #409EFF;
                cursor: pointer;
                font-weight: bold;
            }

        }
        .edit-label-content{
            width: 700px;
            margin: 0 auto;
            border:1px solid #DDDDDD;
            border-radius: 5px;
            padding:10px 150px 10px 100px;
            margin-top: 60px;
            .label_icon{
                width: 24px;
                display: inline-block;
                vertical-align: top;
                margin-right: 8px;
                >img{
                    width: 100%;
                }
            }
            &-name{
                 padding:20px 20px  20px 0px;
                 font-size: 22px;
                color: #333333;
                >span{
                    display: inline-block;
                    font-weight: bold;
                }
            }
            .input-text{
                color: #333333;
            }
        }
    }

</style>
